module.exports = __webpack_public_path__ + "static/League_Gothic-webfont-814d1ae2e8548ea45d5eccb89fd40ab0.woff";